import { Outlet, createFileRoute } from '@tanstack/react-router'

import AppNavigationShell from '@/components/organisms/app-navigation-shell'
import { RegenProvider } from '@/contexts/regen-context'
import { SubscriptionProvider } from '@/contexts/subscription-context'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <SubscriptionProvider>
      <RegenProvider>
        <AppNavigationShell>
          <Outlet />
        </AppNavigationShell>
      </RegenProvider>
    </SubscriptionProvider>
  )
}
